export default __webpack_public_path__ + "static/diag-maze-2aa1e08fd14eeb3c20c62b5745296ce7.webp";